import classNames from "classnames";
import { Button, Image } from "antd";
import MonogramIcon from "assets/images/mongram.jpg";
import { shortenValue, useGlobalMerchant } from "utils/helper";
import { baseImageURL } from "utils/env";
import { useBasket } from 'containers/POSContainer/constant';
import { useStyles } from './style';

const BasketSuiFrensComponent = () => {
    const { itemList, addToBasket, removeFromItem, removeFromBasket } = useBasket();
    const { globalMerchantCurrency } = useGlobalMerchant();

    const handlePlusAction = (productId: string, product: any) => {
        addToBasket(product);
    };
    const handleMinusAction = (productId: string, product: any) => {
        itemList.map((product: any) => {
            if (product.product.product_id === productId) {
                product.qty > 1 ? removeFromItem(productId) : removeFromBasket(productId);
            }
        });
    };
    return (
        <>
            {itemList && itemList.length === 0 && (
                <div className="emptyBasket dFlex alignCenter justifyCenter flexCol gap20 ">
                    <p className="textUpper sLgText fontNormal">Your cart is empty</p>
                    {/* <a className="sBtn">Continue Shopping</a> */}
                </div>
            )}
            {itemList && itemList.length > 0 && itemList.map((items: any) => (
                <div key={items.product.product_id} className='dFlex suifrenCard pcCard alignCenter justifyBetween'>
                    <div className="left dFlex alignCenter gap15">
                        <div className="cPImage">
                            <Image
                                src={items.product.img !== null ? `${baseImageURL}${items.product.img}` : MonogramIcon}
                                alt="product image"
                                preview={false}
                            />
                        </div>
                        <div className="cpNameAvQty dFlex flexCol">
                            <p className="cPName sSmText mb5 fontMedium">{items.product.product_name}</p>
                            <p className="cpAvQty fontMedium  sXSmText"> Available Quantity: <span>{items.product.qty}</span> </p>
                        </div>
                    </div>
                    <div className="cpQty">
                        {items.product.qty == items.qty ? <Button disabled>+</Button> : <Button onClick={() => handlePlusAction(items.product.product_id, items.product)}> +</Button>}
                        <span className="cpQtyNum sSmText inlineFlex alignCenter justifyCenter">{items.qty}</span>
                        {items.qty == 1 ? <Button disabled>-</Button> : <Button onClick={() => handleMinusAction(items.product.product_id, items.product)}>-</Button>}
                    </div>
                    <div className="cpPrice"> <p className="sXMdText fontMedium"> {shortenValue(items.qty * items.product.price)} {globalMerchantCurrency}   </p></div>
                </div>
            ))}
        </>
    )
}

export default BasketSuiFrensComponent